export default function ServiceWorker() {
  let swURL = `${process.env.PUBLIC_URL}/sw.js`;
  navigator.serviceWorker.register(swURL).then((response) => {
    console.warn("ServiceWorker registration successfull: ", response.scope);
  }).catch((error) => {
    console.error("ServiceWorker registration failed: ", error);
  });
}